import { lodestarColors } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
export var scrollAreaTheme = themed({
  keyline: {
    start: {
      boxShadow: {
        vertical: {
          rest: {
            "lodestar-light": "0 2px 0 0 ".concat(lodestarColors.neutral),
            "ursa-light": "0 1px 0 0 ".concat(color("color--border--slate--weaker"))
          },
          scrolling: {
            "lodestar-light": "0 2px 0 0 ".concat(lodestarColors.neutral),
            "ursa-light": color("elevation--shadow-1")
          }
        },
        horizontal: {
          rest: {
            "lodestar-light": "2px 0 0 0 ".concat(lodestarColors.neutral),
            "ursa-light": "1px 0 0 0 ".concat(color("color--border--slate--weaker"))
          },
          scrolling: {
            "lodestar-light": "2px 0 0 0 ".concat(lodestarColors.neutral),
            "ursa-light": "2px 0px 4px rgba(57, 61, 76, 0.16), 6px 0px 12px rgba(65, 80, 139, 0.12)"
          }
        }
      }
    },
    end: {
      boxShadow: {
        vertical: {
          rest: {
            "lodestar-light": "0 -2px 0 0 ".concat(lodestarColors.neutral),
            "ursa-light": "0 -1px 0 0 ".concat(color("color--border--slate--weaker"))
          },
          scrolling: {
            "lodestar-light": "0 -2px 0 0 ".concat(lodestarColors.neutral),
            // Can't use this here since the y offset is negative.
            // color("elevation--shadow-1")
            "ursa-light": "0px -2px 4px rgba(57,61,76,0.16), 0px -6px 12px rgba(65,80,139,0.12)"
          }
        },
        horizontal: {
          rest: {
            "lodestar-light": "-2px 0 0 0 ".concat(lodestarColors.neutral),
            "ursa-light": "-1px 0 0 0 ".concat(color("color--border--slate--weaker"))
          },
          scrolling: {
            "lodestar-light": "-2px 0 0 0 ".concat(lodestarColors.neutral),
            // Can't use this here since the y offset is negative.
            // color("elevation--shadow-1")
            "ursa-light": "-2px 0 4px rgba(57,61,76,0.16), 0px -6px 12px rgba(65,80,139,0.12)"
          }
        }
      }
    }
  }
});
//# sourceMappingURL=scrollAreaTheme.js.map